import { render, staticRenderFns } from "./SupportingDocumentsTab.vue?vue&type=template&id=4b0206ae&scoped=true&"
import script from "./SupportingDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumentsTab.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocumentsTab.vue?vue&type=style&index=0&id=4b0206ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0206ae",
  null
  
)

export default component.exports